// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarFinanceiroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/financeiro/migrar-todas
 * (controllers/migration/financeiro.php::migrar_todas).
 *
 * O fechamento da carga de estrutura financeira de UMA franquia: o run do
 * lote, a contabilidade dos quatro desfechos (MigrationTally — `bloqueadas`
 * NAO entra em `falhas`), o que o proprio Zoho nao conseguiu exportar, e o
 * desfecho de cada agrupador.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre.
 */
import type { Migration_FinanceiroResultadoRow } from './Migration_FinanceiroResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarFinanceiroResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
erros_zoho: string[]
resultados: Migration_FinanceiroResultadoRow[]
}

export type Migration_MigrarFinanceiroResponse = ApiResponse<Migration_MigrarFinanceiroResponseDados>;

registerResponseContract('Migration_MigrarFinanceiroResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
